export const bookingStorageVersion = 1.0;
